import { module } from 'modujs';
import {whenReady} from "../utils/fonts.js";
import {ENV, FONT} from "../config.js";
import {mapRange} from "gsap/gsap-core";
import {$screen} from "../stores/screen.js";
import gsap from 'gsap';
import { isTouchDevice } from '../utils/is.js';

export default class extends module {
    constructor(m) {
        super(m);

        /* Callback */
        this.onProgressBind = this.onProgress.bind(this)
        this.onResizeBind = this.onResize.bind(this)

        /* UI */
        this.$ref = this.$('ref')[0];
        this.$item = this.$('item')[0];
        this.$titleContainer = this.el.previousElementSibling;

        /* Data */
        this.width = 0;
        this.wWidth = window.innerWidth;
    }

    init() {
        if (isTouchDevice()) return

        this.bindEvents()
        whenReady(FONT.EAGER).then((fonts) => this.onFontsLoaded(fonts));
        this.compute()
        this.setTitleTL()
    }

    destroy() {
        this.unbindEvents()
    }

    bindEvents() {
        window.addEventListener('heroProgress', this.onProgressBind);
        this.unbindScreenListener = $screen.subscribe(this.onResizeBind)
    }

    unbindEvents() {
        window.removeEventListener('heroProgress', this.onProgressBind);
        this.unbindScreenListener?.()
    }

    onProgress(e) {        
        let { target, progress } = e.detail;
        
        if(ENV.PREFERS_REDUCED_MOTION) {            
           progress = 0; 
        } 

        if (this.el.contains(target)) {
            const value = mapRange(0, 1, this.width, this.wWidth, progress)
            this.el.style.setProperty('--item-width', `${Math.round(value)}px`);
            this.titleTL?.progress(progress)
        }
    }

    onResize() {
        this.compute();
    }

    onFontsLoaded(fonts) {
        this.compute();
    }

    compute() {
        requestAnimationFrame(() => {
            this.width = this.$ref.offsetWidth
            this.wWidth = window.innerWidth
        })
    }

    setTitleTL() {
        this.titleTL = gsap.timeline({paused: true});
        this.titleTL.to(this.$titleContainer, {duration: 1, autoAlpha: 0, ease: 'power4.out'})
    }
}
